import { ReactNode } from 'react';
import { Flex, Heading } from '@coverflex-tech/hypernova';
import css from './ProductHeader.module.css';

interface IProps {
  title: string;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
}

export function ProductHeader({ title, leftContent, rightContent }: IProps) {
  return (
    <Flex flexDirection="column" gap="xs">
      <Heading level={1} levelSize={4} className={css.title}>
        {title}
      </Heading>
      <div className={css.content}>
        {leftContent}
        {rightContent}
      </div>
    </Flex>
  );
}
